import { RootState } from '../../types';
import { ActionTree } from 'vuex';
import {  IFloorplanViewState, IFloorplanView } from './types';
import ApiProvider from '@/common/apis/ApiProvider';

const loadPromises: {[deviceNumber: string]: Promise<any>} = {};

export const actions: ActionTree<IFloorplanViewState, RootState> = {
    async load({ dispatch, commit, rootState }, args: {deviceNumber: string}): Promise<any> {
        try {
            const views = await dispatch('views/load', args, {root: true});

            let view = views.floorplan as IFloorplanView;
            if (!view) {
                view = {
                    buttons: [],
                };
            }
            commit('loaded', { deviceNumber: args.deviceNumber, view });
        } catch (e) {
            throw e;
        }
    },
    async loadImage({ dispatch, commit, rootState }, args: {deviceNumber: string, force?: boolean}): Promise<any> {
        if (args.force) {
            delete loadPromises[args.deviceNumber];
        }
        return loadPromises[args.deviceNumber]
        || (loadPromises[args.deviceNumber] = new Promise<any>(async (resolve, reject) => {
            try {
                const api = ApiProvider.getDeviceApi();
                const data = await api.getFileAsBytes('/floorplan.data', args.deviceNumber);

                resolve(data);
            } catch (e) {
                delete loadPromises[args.deviceNumber];
                reject(e);
            }
        }));
    },
    async pushToViews({state, dispatch}, args: {deviceNumber: string}): Promise<any> {
        const view = state.devices[args.deviceNumber];
        if (view) {
            await dispatch('views/store', {
                deviceNumber: args.deviceNumber,
                key: 'floorplan',
                payload: view },
                { root: true },
            );
        }
    },
};
